var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.row.label))]),_vm._l((_vm.row.tags),function(tag){return _c('div',{key:tag.id},[_c('DeviceTagIcon',{attrs:{"color":_vm.getTagColor(tag.id)}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }